import { countryNames } from '@/lib/constants/country-names';

/**
 * Returns a country name for a location countryCode
 */
export const getLocationCountryName = (countryCode: string): string => {
  return countryNames[countryCode];
};
